// extracted by mini-css-extract-plugin
export default {"root":"active_contracts_root__fDUZn","statusLabel":"active_contracts_statusLabel__Pejf3","search_input_container":"active_contracts_search_input_container__7WH6+"};